import React from "react";
import BackLink from "../../../shared/BackLink";

export default function PavShopReports() {
  return (
    <div>
      <h1>PAV Shop Reports</h1>
      <BackLink />
    </div>
  );
}
